import { useState } from "react";
import ReactDOM from "react-dom";

import { UnsubscribeOptions } from "@enums/common.enum";
import { Radio } from "@ui/FormElements";
import { Spinner } from "@ui/Loaders";
import { Button } from "@ui/Button";

interface Props {
  isPending: boolean;
  onSubmit: (option: UnsubscribeOptions) => void;
  onCancel: () => void;
}

export function UnsubscribeSection({ isPending, onSubmit, onCancel }: Props) {
  const [chosenOption, setChosenOption] = useState(UnsubscribeOptions.UNSUBSCRIBE);

  const unsubscribeOptions = [
    {
      label: "Unsubscribe from future emails",
      value: UnsubscribeOptions.UNSUBSCRIBE,
    },
    {
      label: "Keep this email only",
      value: UnsubscribeOptions.KEEP_THIS_EMAIL_ONLY,
    },
    {
      label: "Delete the whole thread",
      value: UnsubscribeOptions.REMOVE_THREAD,
    },
  ];

  const handleSubmit = () => onSubmit(chosenOption);

  const modal = (
    <>
      <div className="fixed inset-0 bg-gray-100 dark:bg-gray-950 opacity-40 z-[43]" />
      <section className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90vw] max-w-[400px] bg-white dark:bg-gray-700 text-[black] flex flex-col gap-4 rounded-xl p-4 z-[50] shadow-lg max-h-[80vh] overflow-y-auto">
        <p className="text-gray-450 dark:text-invertedPrimary80 text-xs font-[400] text-center">
          What would you like to do with this thread?
        </p>
        <div className="flex flex-col gap-2 w-full">
          {unsubscribeOptions.map((option, index) => (
            <Radio
              key={option.value}
              id={`unsubscribe-${index}`}
              label={option.label}
              value={option.value}
              isChecked={chosenOption === option.value}
              onChange={() => setChosenOption(option.value)}
              labelClass="text-[13px] dark:text-white font-[400]"
            />
          ))}
        </div>
        <div className="flex flex-col gap-2">
          <Button className="w-full max-w-[300px]" buttonType={"PRIMARY"} onClick={handleSubmit}>
            {isPending ? <Spinner size={20} /> : "Apply Changes"}
          </Button>
          <Button
            className="text-gray-800 dark:text-invertedPrimary80 dark:bg-gray-700 dark:hover:bg-gray-600 w-full max-w-[300px] border-gray-325 z-[9]"
            buttonType="TRANSPARENT"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </div>
      </section>
    </>
  );

  return ReactDOM.createPortal(modal, document.body);
}
